import get from 'transmute/get';
export const getAuth = get('auth');